module.exports = __webpack_public_path__ + "img/key-group.d9592302.png";